const convertGregorianTimeToShamsiTime = (
  dateTime: string | Date | null | undefined,
  showTime: boolean = true,
  numericMonth = false,
  reverseTime: boolean = false
) => {
  if (!dateTime) return ''

  const time = typeof dateTime === 'string' ? new Date(dateTime) : dateTime

  const persianTime = time.toLocaleDateString('fa-IR', {
    hour: 'numeric',
    minute: '2-digit',
    month: numericMonth ? 'numeric' : 'long',
    day: '2-digit',
    year: 'numeric'
  })

  const persianDate = time.toLocaleDateString('fa-IR', {
    month: numericMonth ? 'numeric' : 'long',
    day: '2-digit',
    year: 'numeric'
  })

  if (!showTime) return persianDate

  const splitToken = numericMonth ? ',' : 'ساعت'
  const parts = persianTime.split(splitToken)

  const finalParts = reverseTime ? parts.toReversed() : parts

  return finalParts.join(' - ')
}

export default convertGregorianTimeToShamsiTime
